module.exports = __webpack_public_path__ + "img/photo-40.0c86a109.webp";